import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { useExteriorDamageImages } from '../../hooks/useExteriorDamageImages';

export const ExteriorDamage = () => {
  const damagedImages = useExteriorDamageImages();

  if (damagedImages.length === 0) return null;

  return (
    <Level2Wrapper flex="1 1 100%" label="Damage">
      <ImageList label="Damage Pictures" images={damagedImages} />
    </Level2Wrapper>
  );
};
